
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1ubbm_1dtxc_5",
  "hints": "awsui_hints_1ubbm_1dtxc_6"
};
  